import { api } from "./client";

export async function login(email, password) {
  const { data } = await api.post("/api/auth/login", { email, password });
  return data; // { token, rol, nombre, local_id, local_nombre }
}

export async function me() {
  const { data } = await api.get("/api/auth/me");
  return data;
}
